// extracted by mini-css-extract-plugin
export default {"products":"hw-z","card":"iw-z","oosMessaging":"jw-z"};